var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label}},[_c('c-switch',_vm._b({attrs:{"color":"success","variant":"pill","label":"","disabled":_vm.disabled},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},'c-switch',{
            dataOn: _vm.$t('form.switch.yes'),
            dataOff: _vm.$t('form.switch.no'),
        },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }